import { render, staticRenderFns } from "./demo.rules.default.vue?vue&type=template&id=926dd69e&"
import script from "./demo.rules.default.vue?vue&type=script&lang=ts&"
export * from "./demo.rules.default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports